import React from "react";

import AITasksListPanel from "./AITasksListPanel";
import IssbContainer from "../IssbContainer";


export default function AITasksListPage() {
	return (
		<IssbContainer>
			<AITasksListPanel />
		</IssbContainer>
	);
};

